import { GroupedData, TableColumnConfigInterface } from '../../table.interface';
import { GroupOptionsInterface } from './row.grouper.interface';

export class RowGrouper<T> {
  private _config: Record<string, TableColumnConfigInterface<T>>;

  constructor(config: TableColumnConfigInterface<T>[] | Record<string, TableColumnConfigInterface<T>>) {
    this._config = Array.isArray(config)
      ? config.reduce((acc, column) => {
          acc[column.key as string] = column;
          return acc;
        }, {})
      : config;
  }

  public static readonly groupLabelMappers = {
    boolean: (val, opts: GroupOptionsInterface) => (val ? 'ja' : 'nee'),
    'boolean-sync': (val, opts: GroupOptionsInterface) => (val ? 'ja' : 'nee'),
    switch: (val, opts: GroupOptionsInterface) => (val ? 'ja' : 'nee'),
    date: (val, opts: GroupOptionsInterface) => new Date(val).toLocaleDateString(opts.locale),
    datetime: (val, opts: GroupOptionsInterface) => new Date(val).toLocaleDateString(opts.locale),
    time: (val, opts: GroupOptionsInterface) => new Date(val).toLocaleTimeString(opts.locale),
    default: (val, opts: GroupOptionsInterface) => `${val}`,
  };

  public group(
    groupBy: string,
    data: T[],
    allData: T[],
    { locale = 'nl-BE' }: GroupOptionsInterface = {}
  ): GroupedData<T>[] | T[] {
    const mapper = this._getGroupLabelMapper(this._config[groupBy]);

    const grouped = data.reduce((acc, item) => {
      const key = mapper(item[groupBy], { locale });
      acc[key] ??= [];
      acc[key].push(item);
      return acc;
    }, {} as Record<string, T[]>);

    return Object.entries(grouped).map(([key, value]) => {
      return {
        [groupBy]: key,
        open: true,
        children: value,
        allChildren: allData.filter((d) => key === mapper(d[groupBy], { locale })),
      };
    });
  }

  private _getGroupLabelMapper(
    column: TableColumnConfigInterface<T>
  ): (val: any, opts: GroupOptionsInterface) => string {
    if (!column?.type) {
      return RowGrouper.groupLabelMappers['default'];
    }

    if (RowGrouper.groupLabelMappers[column.type]) {
      return RowGrouper.groupLabelMappers[column.type];
    }

    return RowGrouper.groupLabelMappers['default'];
  }
}
